import React from 'react';
import { ProgressBar } from 'react-bootstrap';

import useGlobal from '../../../../../store';
import { TheError } from '../../../../../shared/responses/TheResult';

const mapState = (store) => {
  return store.modulo.recepcion.upload;
};

const mapActions = (actions) => {
  return { ...actions.modulo.recepcion.upload };
};

const RecepcionUploadForm = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { data, progress, busy, error } = state;

  const select = (event) => {
    actions.onChange({
      file: event.target.files[0],
    });
  };

  return (
    <>
      {!!error && <TheError error={error} />}

      <label>
        <input
          type="file"
          accept=".xml"
          onChange={select}
        />
      </label>

      <div className="p-3">
        <label>Instrucciones.</label>
        <ul className="list-unstyled">
          <li>1. Selecciona el XML de tu comprobante a validar</li>
          <li>2. Sube el archivo</li>
        </ul>
      </div>

      {(busy || progress > 0) && !!data.file && (
        <ProgressBar
          striped
          variant="info"
          label={`${progress}%`}
          now={progress}
        />
      )}
    </>
  );
};

export default RecepcionUploadForm;
